export const smallLogo = "/logo_white_cropped.png";
export const bigLogo = "/logo_full_white_cropped.png";
export const logoFullBlack = "/logo_full_black.png";